"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.GlobalNotification = void 0;
var react_1 = __importDefault(require("react"));
var GenericNotification_1 = __importDefault(require("./components/GenericNotification"));
/**
 * @deprecated Please use the same component from `@kaizen/components`
 */
var GlobalNotification = function (props) { return react_1["default"].createElement(GenericNotification_1["default"], __assign({ style: "global" }, props)); };
exports.GlobalNotification = GlobalNotification;
exports.GlobalNotification.defaultProps = {
    persistent: false
};
exports.GlobalNotification.displayName = "GlobalNotification";
//# sourceMappingURL=GlobalNotification.js.map